const getPatientRecordNumber = ({ patient, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }

  return patient['Record Number'];
};

export default getPatientRecordNumber;



// WEBPACK FOOTER //
// ./src/utils/print/getPatientRecordNumber.js